// app/javascript/controllers/scroll_into_view_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("shown.bs.collapse", this.scrollIntoView);
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.collapse", this.scrollIntoView);
  }

  scrollIntoView = () => {
    this.element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
